import React from 'react';

import { ConfirmModal } from '@nutanix-ui/prism-reactjs';
import type { ConfirmModalProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Modal/ConfirmModal';

import { type ButtonProps, ButtonTypes } from '../Button/Button';
import type { DialogSize } from './Dialog';
import { dialogSizeToWidth } from './Dialog';

export type ConfirmDialogProps = Omit<ConfirmModalProps, 'size' | 'title'> & {
  isOpen?: boolean;
  title?: string | React.ReactNode;
  cancelButtonProps?: ButtonProps;
  confirmButtonProps?: ButtonProps;
  size?: DialogSize;
};

export default function ConfirmDialog({
  isOpen,
  title,
  confirmButtonLabel = 'Confirm',
  cancelButtonLabel = 'Cancel',
  cancelButtonProps,
  confirmButtonProps,
  onConfirm,
  onCancel,
  size,
  ...modalProps
}: ConfirmDialogProps) {
  const submitButtonProps = { type: ButtonTypes.DESTRUCTIVE, ...confirmButtonProps };
  const closeButtonProps = { type: ButtonTypes.SECONDARY, ...cancelButtonProps };

  return (
    <ConfirmModal
      data-test="confirm-modal"
      {...modalProps}
      header={title}
      visible={isOpen}
      closeOnEscape={true}
      confirmButtonLabel={confirmButtonLabel}
      cancelButtonLabel={cancelButtonLabel}
      confirmButtonProps={submitButtonProps}
      cancelButtonProps={closeButtonProps}
      onCancel={onCancel}
      onConfirm={onConfirm}
      restoreFocus={true}
      width={size ? dialogSizeToWidth[size] : undefined}
    />
  );
}
